const pendingRequests = {};

const apiCache = {
  productData: {},
  repaymentData: {},
  secciDocuments: {}
};

/**
 * Makes a fetch request with deduplication
 * @param {string} url - The URL to fetch
 * @param {string} cacheKey - The key to use for caching
 * @param {string} cacheType - The type of cache to use
 * @param {Object} options - Fetch options
 * @returns {Promise<any>} - The response data
 */
export const fetchWithCache = async (url, cacheKey, cacheType, options = {}) => {

  if (apiCache[cacheType] && apiCache[cacheType][cacheKey]) {
    console.log(`Using cached ${cacheType} for ${cacheKey}`);
    return apiCache[cacheType][cacheKey];
  }


  const requestKey = `${url}_${JSON.stringify(options)}`;
  if (pendingRequests[requestKey]) {
    console.log(`Reusing pending request for ${url}`);
    return pendingRequests[requestKey];
  }

  const requestPromise = new Promise(async (resolve, reject) => {
    try {
      console.log(`Making new request to ${url}`);
      const response = await fetch(url, options);

      if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
      }

      let data;
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        data = await response.json();
      } else {
        data = await response.text();
      }

      if (apiCache[cacheType]) {
        apiCache[cacheType][cacheKey] = data;
      }

      resolve(data);
    } catch (error) {
      console.error(`Error fetching ${url}:`, error);
      reject(error);
    } finally {
      delete pendingRequests[requestKey];
    }
  });

  pendingRequests[requestKey] = requestPromise;

  return requestPromise;
};

/**
 * Clear the entire cache or a specific cache type
 * @param {string} cacheType - Optional cache type to clear
 */
export const clearCache = (cacheType = null) => {
  if (cacheType && apiCache[cacheType]) {
    apiCache[cacheType] = {};
  } else if (!cacheType) {
    Object.keys(apiCache).forEach(key => {
      apiCache[key] = {};
    });
  }
};

/**
 * Get API cache object
 */
export const getCache = () => apiCache;

export default apiCache;
